import {SetStateAction, useEffect, useState} from 'react';
import {useGetDocMetadataFilterOptionsQuery} from '../../../../hooks/document/useDocument';
import {ISelectItem} from '../../../../shared/types';
import ArrMultiSelectLazyLoadDropdown from '../../../common/arr-select-dropdown/ArrMultiSelectLazyLoadDropdown';
import {ActiveFilter} from '../doc-filter-accordion/DocExplorerFilterAccordion';

export interface LazyLoadFilter {
  setFilterData: (value: SetStateAction<ActiveFilter>) => void;
  filterData: ActiveFilter;
  id: string;
  onDropdownToggle?: (isOpen: boolean) => void;
}
const LazyLoadFilter: React.FC<LazyLoadFilter> = ({
  setFilterData,
  filterData,
  id,
  onDropdownToggle,
}) => {
  const {mutateAsync: fetchFilterOptions, isPending: isLoadingMore} =
    useGetDocMetadataFilterOptionsQuery();

  const [page, setPage] = useState(1);
  const [options, setOptions] = useState<ISelectItem[]>([]);
  const [hasMore, setHasMore] = useState(true);

  const [search, setSearch] = useState('');

  useEffect(() => {
    setPage(1);
    setOptions([]);
    setHasMore(true);
    setSearch('');
  }, [id]);

  const fetchPage = async (pageNum: number, searchStr = '') => {
    const payload = {
      FieldId: id,
      Query: encodeURIComponent(searchStr),
      PageNumber: pageNum,
      PageSize: 50,
    };
    const res = await fetchFilterOptions(payload);
    const newData = res?.data || [];
    setOptions((prev) => (pageNum === 1 ? newData : [...prev, ...newData]));
    setHasMore((newData?.length ?? 0) >= 50);
  };

  // called when dropdown opens or when search changes (debounced)
  const handleDropdownOpen = (searchStr?: string) => {
    setSearch(searchStr ?? '');
    setPage(1);
    fetchPage(1, searchStr ?? '');
  };

  // called when scroll triggers load more
  const handleLoadMore = (searchStr?: string) => {
    if (!hasMore || isLoadingMore) return;
    const next = page + 1;
    setPage(next);
    fetchPage(next, searchStr ?? search);
  };
  return (
    <ArrMultiSelectLazyLoadDropdown
      dataTestId={`${filterData?.label?.replaceAll(' ', '').toLowerCase()}-filter-selected-options`}
      checkboxDataTestId="doc-explorer-lazy-load-filter-dropdown-checkbox"
      aria-label={filterData.label}
      dropdownLabel={filterData.label}
      dropdownItems={options}
      dropdownItemKey="text"
      dropdownItemDisplay="text"
      selectedValues={filterData.values ?? []}
      onSelectionChange={(val) =>
        setFilterData((prev) => ({...prev, values: val}))
      }
      multiple
      searchable
      shouldLoadOnOpen
      onDropdownOpen={handleDropdownOpen}
      onLoadMore={handleLoadMore}
      hasMore={hasMore}
      isLoadingMore={isLoadingMore}
      onDropdownToggle={onDropdownToggle}
    />
  );
};

export default LazyLoadFilter;
